import React, { useEffect, useState } from 'react';
import Loading from './Loading';
import Dropdown from 'react-dropdown';
import '../styles/_subscriptionsTable.scss';
import Popup from './Popup';
import PayPalButtons from './PayPalButtons';
import * as moment from 'moment';
import * as _ from 'lodash';

// https://developer.paypal.com/docs/api/subscriptions/v1/#subscriptions_create

const DashboardMembershipsTable = ({ user, token, tiers, vehicles, memberships, loading, dataError, onAddSubscription }) => {
  const [loadingWait, setLoadingWait] = useState(false);
  const [showMembership, setShowMembership] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [membershipLoading, setMembershipLoading] = useState(false);
  const [membershipError, setMembershipError] = useState('');
  const [myMemberships, setMyMemberships] = useState([]);
  const [groupedMemberships, setMyGroupedMemberships] = useState();
  const [memberData, setMemberData] = useState({
    tierId: '',
    vehicles: []
  })
  const [tiersUsed, setTiersUsed] = useState([])
  const [step, setStep] = useState(0)

  useEffect(() => {
    // show loading animation for at least 2 seconds
    setTimeout(function () {
      setLoadingWait(true)
    }, 2000);
  }, [])

  useEffect(() => {
    mapResults(memberships);
  }, [memberships])
  
  useEffect(() => {
    if (showMembership || showCancel) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [showMembership, showCancel])

  useEffect(() => {
    if (!showMembership) {
      // hiding membership popup, reset stages
      resetMembership();
    }
  }, [showMembership])

  const [selectedTier, setSelectedTier] = useState({});
  const onChangeTier = (e) => {
    setMemberData({
      ...memberData,
      tier: e.value
    })

    const t = tiers.find(t => t.id === e.value);
    setSelectedTier(t);
    setMembershipError('');
  }

  useEffect(() => {
    getButtonTitle()
  }, [selectedTier])

  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const onChangeCheckbox = (e) => {
    setMembershipError('');

    const vehicles = [...selectedVehicle]
    if (!vehicles.includes(+e.target.value)) {
      vehicles.push(+e.target.value)
    } else {
      // remove
      const idx = vehicles.findIndex(v => +v === +e.target.value)
      vehicles.splice(idx, 1)
    }

    setSelectedVehicle(vehicles.map(v => v))
  }

  const onAddNewMembership = async (subscriptionId) => {
    setMembershipError('');
    setMembershipLoading(true);

    // want to wait for all promises to complete before continuing
    setupAsyncPromises(subscriptionId).then(results => {
      // array of results in order here
      onAddSubscription();
      resetMembership();
      setShowMembership(false);
    }).catch(err => {
        console.log(err);
    });
  }

  // setting up array of async promises
  const setupAsyncPromises = (subscriptionId) => {
    const promises = []

    for (let i = 0; i < selectedVehicle.length; i++) {
      promises.push(onAdd(selectedVehicle[i], subscriptionId));
    }
    
    // executing the promises
    return Promise.all(promises)
  }

  const onAdd = async (vehicle, subscriptionId) => {
    try {
      const rawResponse = await fetch(`/api/subscriptions`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          selectedVehicle: vehicle,
          userId: user.id,
          tierId: selectedTier.id,
          orderId: subscriptionId
        })
      });

      return await rawResponse.json();
    } catch (error) {
      console.log(error)
    }
  }

  const [buttonTitle, setButtonTitle] = useState('')
  const mapResults = (result) => {
    if (result && !result.error && result[0]) {
      // determine order of tiers
      const tiersByCost = tiers.sort((a,b) => (+a.cost > +b.cost) ? 1 : ((+b.cost > +a.cost) ? -1 : 0)).map(t => t.id)
      const mappedResults = result.map(r => {
        return {
          startDate: moment(r.startDate).format('MM/DD/YYYY'),
          expirationDate: moment(r.expirationDate).format('MM/DD/YYYY'),
          // status: moment().startOf('day').isAfter(moment(r.expirationDate).endOf('day')) ? 'Expired' : 'Active',
          status: r.status,
          membership: r.subscriptionTier.name,
          vehicle: r.vehicle.licensePlate,
          vehicleString: `${r.vehicle.color} ${r.vehicle.make} ${r.vehicle.model} - ${r.vehicle.licensePlate}`,
          cost: '$' + r.subscriptionTier.cost,
          tierId: r.subscriptionTier.id,
          sortt: tiersByCost.indexOf(r.tierId),
          sub: r.orderId
        }
      }).filter(r => moment(r.expirationDate).isAfter(moment()))

      const sortedCost = mappedResults.sort((a,b) => (+a.sortt > +b.sortt) ? 1 : ((+b.sortt > +a.sortt) ? -1 : 0));
      const sorted = sortedCost.sort((a,b) => (a.status !== 'ACTIVE') ? 1 : ((b.status !== 'ACTIVE') ? -1 : 0))

      const subTypes = [];
      sorted.forEach(sub => {
        if (subTypes.includes(sub.sortt)) {
          const tierId = tiersByCost[sub.sortt];
          const t = tiers.find(t => t.id === tierId);
          if (t) {
            sub.cost = '$' + t.discountedCost;
          } else {
            sub.cost = '$'
          }
        } else {
          subTypes.push(sub.sortt)
        }
      });
      setMyMemberships(sorted)
      setTiersUsed(sorted.filter(s => s.status !== 'CANCELLED').map(m => m.membership))
      getButtonTitle()

      const grouped = _.groupBy(sorted, 'membership');
      setMyGroupedMemberships(grouped);
    }
  }

  const resetMembership = () => {
    setMembershipError('');
    setSelectedTier({});
    setSelectedVehicle([]);
    setStep(0);
    setMembershipLoading(false);
    setMemberData({
      tierId: '',
      vehicles: []
    });
    setShowCancel(false);
  }

  const [options, setOptions] = useState([]);
  useEffect(() => {
    const opt = tiers.sort((a,b) => (+a.cost > +b.cost) ? 1 : ((+b.cost > +a.cost) ? -1 : 0)).filter(t => !t.isOff).map(t => {
      return {
        value: t.id,
        label: `${t.name} - $${t.cost}`
      }
    })
    setOptions(opt.reverse())
  }, [tiers])

  const getButtonTitle = () => {
    if (step === 0) {
      if (tiersUsed && tiersUsed.includes(selectedTier.name)) {
        setButtonTitle('Cancel Subscription')
      } else {
        setButtonTitle('Continue')
      }
    } else if (step === 1) {
      setButtonTitle('Continue')
    } else if (step === 3) {
      setButtonTitle('Cancel Membership')
    }
  }

  const buttonAction = () => {
    if (step === 0) {
      if (!selectedTier || !selectedTier.name) {
        setMembershipError('Please select a tier.')
      } else {
        if (tiersUsed && tiersUsed.includes(selectedTier.name)) {
          setStep(3)
        } else {
          setMembershipError('')
          setStep(1)
        }
      }
    } else if (step === 1) {
      if (selectedVehicle.length === 0) {
        setMembershipError('Please select at least one (1) vehicle.')
      } else {
        setMembershipError('')
        setStep(2)
      }
    } else if (step === 3) {
      const cancelMemberships = myMemberships.filter(m => m.membership === selectedTier.name)
      if (cancelMemberships.length > 0 && cancelMemberships[0]) {
        const cancelSubscription = cancelMemberships[0].sub
        onCancelSubscription(cancelSubscription)
      }
    }
  }

  const backButtonAction = () => {
    if (step === 1 || step === 3) {
      setStep(0)
    } else if (step === 2) {
      setStep(1)
    }
  }

  const onCancelSubscription = async (cancelId) => {
    try {
      // cancel a subscription
      const rawResponse =  await fetch(`https://api-m.paypal.com/v1/billing/subscriptions/${cancelId}/cancel`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });

      if (rawResponse.status === 204) {
        const cancelledResponse = await fetch(`/api/subscriptions/${user.id}/cancel/${cancelId}`, {
          method: 'DELETE',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });

        const cancelled = await cancelledResponse.json();
        const cancelledTiers = cancelled.map(c => c.subscriptionTier.name)
        setTiersUsed(tiersUsed.filter(t => !cancelledTiers.includes(t)))
        
        resetMembership()
        onAddNewMembership()
        setMembershipLoading(false)
      } else {
        setMembershipError('There was a problem canceling your subscription. Please cancel via your PayPal portal.')
        setMembershipLoading(false)
      }
    } catch (error) {
      console.log(error)
      setMembershipError('There was a problem canceling your subscription. Please cancel via your PayPal portal.')
      setMembershipLoading(false)
    }
  }

  const onAttemptCancel = (tierId) => {
    const t = tiers.find(t => t.id === tierId);

    setSelectedTier(t);
    setShowCancel(true)
  }

  const onCancelMembership = () => {
    setMembershipLoading(true)

    const cancelMemberships = myMemberships.filter(m => m.membership === selectedTier.name)
    if (cancelMemberships.length > 0 && cancelMemberships[0]) {
      const cancelSubscription = cancelMemberships[0].sub
      onCancelSubscription(cancelSubscription)
    } else {
      setMembershipLoading(false)
    }
  }

  return (
    <>
      { dataError !== '' &&
         <p className="table-message">{ dataError }</p>
      } 

      { dataError === '' && !loading && memberships.length === 0 &&
        <>
          <p className="table-message">{'You have no membership subscriptions, or we could not verify active subscriptions with PayPal :('}</p>
          <div className="btn primary" onClick={() => setShowMembership(true)}>+ Add Subscription</div>
        </>
      }
      
      { dataError === '' && (loading || memberships.length > 0) &&
        <>
          <div className="sub-list">
            {groupedMemberships && Object.keys(groupedMemberships).map((result, index) => {
              return (
                <div key={'membershiplist--' + index} className="sub-listitem">
                  <div className="mobile-cancel">
                    <h3>{result}</h3>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <i className={`fa fa-window-close cancel-sub ${groupedMemberships[result][0].status}`} style={{fontSize: '25px', color: '#ad7100', marginRight: '1rem'}} onClick={() => groupedMemberships[result][0].status !== 'CANCELLED' ? onAttemptCancel(groupedMemberships[result][0].tierId) : null}></i>
                    </div>
                  </div>
                 
                  {groupedMemberships[result] && groupedMemberships[result].map((mem, index) => {
                    return (
                      <div key={'membershipbehicle--' + index}>
                        <h4>{mem.vehicle}</h4>
                        <ul>
                          <li><b>Start Date:</b> {mem.startDate}</li>
                          <li><b>Expiration Date:</b> {mem.expirationDate}</li>
                          <li style={mem.status === 'EXPIRED' || mem.status === 'CANCELLED' ? {color: 'red'} : {color: 'green'}}><b>Status:</b> {mem.status}</li>
                          <li><b>Cost:</b> {mem.cost}</li>
                        </ul>
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
          <div className="sub-table">
            { (loading || !loadingWait) &&
              <Loading></Loading>
            }
            <table>      
              <thead>
                <tr>
                  <th>Start</th>
                  <th>Expiration</th>
                  <th>Status</th>
                  <th>Membership</th>
                  <th>Vehicle</th>
                  <th>Cost</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {myMemberships && myMemberships[0] && myMemberships.map((result, index) => {
                  return (
                    <tr key={'membership--' + index} className={`${index % 2 === 1 ? 'highlight' : ''}`}>
                      <td>{result.startDate}</td>
                      <td>{result.expirationDate}</td>
                      <td className={result.status === 'Expired' ? 'expired' : ''}>{result.status}</td>
                      <td>{result.membership}</td>
                      <td>{result.vehicle}</td>
                      <td>{result.cost}</td>
                      <td>
                        <i className={`fa fa-window-close cancel-sub ${result.status}`} onClick={() => result.status !== 'CANCELLED' ? onAttemptCancel(result.tierId) : null}></i>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          {vehicles && myMemberships && vehicles.length > myMemberships.filter(r => r.status !== 'CANCELLED').length &&
            <div className="btn primary" onClick={() => setShowMembership(true)}>+ Add Subscription</div>
          }
        </>
      }

      <Popup
        showPopup={showMembership}
        loading={membershipLoading}
        setShowPopup={setShowMembership}
        user={user}
        title={'Add Membership Subscription'}
        buttonTitle={buttonTitle}
        buttonAction={buttonAction}
        backButton={step > 0}
        backButtonAction={backButtonAction}
        error={membershipError}
        hideSubmit={!!(step === 2)}
      >
        <>
          {step === 0 &&
            <div style={{marginBottom: '1rem', width: '98%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <p className="popup-description"><b>Step 1: Select a membership type.</b></p>
              { showMembership && (!selectedTier || !selectedTier.id) &&
                <p className="popup-description" style={{marginTop: 0, maxWidth: '400px', marginBottom: '2rem'}}>Subscribe your vehicle(s) in order to take advantage of Quik Quality membership services.</p>
              }
              <Dropdown
                options={options}
                onChange={(e) => onChangeTier(e)}
                value={memberData.tier}
                placeholder="Select a subscription"
                className="custom-dropdown"
              />
              
              { selectedTier.id && !tiersUsed.includes(selectedTier.name) &&
                <div className="vehicle-select">
                  <p className="tier-description"><b>{selectedTier.name}</b>: {selectedTier.description}</p>
                  <p className="tier-description vehicle-details"><b>${selectedTier.cost}</b> per month for the first vehicle</p>
                  <p className="tier-description"><b>+ ${selectedTier.discountedCost}</b> for every additional vehicle</p>
                </div>
              }

              {tiersUsed && tiersUsed.includes(selectedTier.name) &&
                <>
                  <p className="tier-description" style={{color: 'red', textAlign: 'center'}}>You already have vehicles assigned to this membership tier.</p>
                  <p className="tier-description" style={{textAlign: 'center'}}>If you want to add a vehicle, you have to cancel your existing membership and create a new one with the correct vehicle(s).</p>
                </>
              }
            </div>
          }

          {step === 1 &&
            <>
              <p className="popup-description"><b>Step 2: Select vehicle(s).</b></p>
              <p className="popup-description select-vehicle" style={{marginTop: 0, maxWidth: '400px'}}>Be sure to select all vehicles that will use <b>{selectedTier.name}</b>. To edit these selections later, you will need to cancel the subscription.</p>
              <div style={{marginBottom: '1rem'}}>
                {vehicles && vehicles.length > 0 && vehicles.filter(v => v.subscriptionId === null || v.status === 'CANCELLED').map(v => {
                  return (
                    <label className="container" key={'selectvehicle--' + v.memberNumber}>{v.year} {v.make} {v.model} - {v.licensePlate}
                      <input type="checkbox" value={v.memberNumber} checked={selectedVehicle.includes(v.memberNumber)} onChange={(e) => onChangeCheckbox(e)}/>
                      <span className="checkmark"></span>
                    </label>
                  )})
                }
              </div>
            </>
          }
          

          {step === 2 &&
            <>
              <p className="popup-description"><b>Step 3: Subscribe.</b></p>
              <p className="popup-description" style={{marginTop: 0, maxWidth: '400px', marginBottom: '1.5rem'}}>Use the PayPal buttons below to pay for <b>{selectedVehicle.length} vehicle(s)</b> with membership <b>{selectedTier.name}</b>.</p>
              {/* <div className="btn primary" onClick={() => onAddNewMembership('XXXX')}>Click Me</div> */}
              <PayPalButtons
                token={token}
                selectedTier={selectedTier}
                selectedVehicle={selectedVehicle}
                onSubscriptionApprove={(subscriptionId) => onAddNewMembership(subscriptionId)} />
            </>
          }

          {step === 3 &&
            <div style={{paddingBottom: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <p className="popup-description">Are you sure you want to cancel <b>{selectedTier.name}</b>?</p>
              <p className="popup-description" style={{marginTop: 0, maxWidth: '400px', marginBottom: '1.5rem'}}>Once complete, you will need to re-subscribe the following vehicle(s) in order for them to take advantage of Quik Quality membership services:</p>
              <div style={{paddingBottom: '1rem'}}>
                {myMemberships && myMemberships[0] && myMemberships.filter(m => m.membership === selectedTier.name).map((result, index) => {
                  return (
                    <label className="container" key={'vehicle--' + result.vehicle}>{result.vehicleString}
                      <input type="checkbox" checked="checked" readOnly={true} />
                      <span className="checkmark"></span>
                    </label>
                  )
                })}
              </div>
            </div>
          }
        </>
      </Popup>

      <Popup
        showPopup={showCancel}
        loading={membershipLoading}
        setShowPopup={setShowCancel}
        user={user}
        title={'Cancel Membership Subscription'}
        buttonTitle={'Cancel'}
        buttonAction={onCancelMembership}
        error={membershipError}
      >
        <>
          <div style={{marginBottom: '1rem', width: '98%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <p className="popup-description" style={{marginBottom: 0}}><b>{selectedTier.name}</b></p>
            <p className="popup-description" style={{marginBottom: '2rem'}}>The following vehicles are included in this subscription. Canceling your subscription will cancel the membership for all vehicles shown here. You can create a new subscription at any time!</p>
            <div style={{marginBottom: '1rem'}}>
              {vehicles && vehicles.length > 0 && vehicles.filter(v => v.subscriptionId !== null && v.tierId === selectedTier.id).map(v => {
                return (
                  <label className="container" key={v.memberNumber}>{v.year} {v.make} {v.model} - {v.licensePlate}
                    <input type="checkbox" checked="checked" />
                    <span className="checkmark"></span>
                  </label>
                )})
              }
            </div>
          </div>
          
        </>
      </Popup>
    </>
  )
}

export default DashboardMembershipsTable;